export default __webpack_public_path__ + "static/Chalet-LondonSixty-d1c0b23df4ac37779365341d67f69e2a.woff2";